import { render, staticRenderFns } from "./EditLoanTierComponent.vue?vue&type=template&id=1c460870&"
import script from "./EditLoanTierComponent.vue?vue&type=script&lang=js&"
export * from "./EditLoanTierComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports